import { Form } from 'react-bootstrap'

const FeedBack = Form.Control.Feedback

export default FeedBack
